import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login/Login.vue';
import Dashboard from '@/components/Dashboard';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/dashboard',
      name: 'Login',
      component: Login,
    },
    {
      path: '/dashboard/buildings/:id/:floor_id/:room_id',
      name: 'building-instance',
      component: Dashboard,
      meta: {
        auth: true,
      },
    },
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});
